{
  "name": "partner-portal-frontend",
  "type": "module",
  "version": "2.0.29",
  "engines": {
    "node": ">=22.0.0",
    "npm": ">=6.14.15"
  },
  "scripts": {
    "dev": "vite",
    "build": "vite build --mode production",
    "coverage": "npx nyc --reporter=lcov --reporter=text-summary playwright test",
    "preview": "vite preview --port 4173",
    "test:e2e": "start-server-and-test preview http://localhost:4173/ 'cypress open --e2e'",
    "test:e2e:ci": "start-server-and-test preview http://localhost:4173/ 'cypress run --e2e'",
    "test:e2e:playwright": "npx playwright test",
    "test:e2e:playwright:ui": "npx playwright test --ui",
    "test:e2e:playwright:headed": "npx playwright test --headed",
    "test:e2e:playwright:debug": "npx playwright test --debug",
    "test:unit": "cypress open --component",
    "test:unit:ci": "cypress run --component --quiet --reporter spec",
    "test:vitest": "vitest",
    "test:vitest:ci": "vitest run",
    "prepare": "husky install",
    "prettier": "prettier --write \"src/**/*.{js,vue}\"",
    "release": "release-it --only-version --no-git.requireUpstream",
    "lint": "eslint . --ext .vue,.js,.jsx,.cjs,.mjs --fix --config .eslintrc.cjs",
    "lint:style": "stylelint \"./**/*.{css,scss,vue}\" --fix  && prettier  \"./**/*.{css,scss,vue}\" -w"
  },
  "dependencies": {
    "@capacitor-firebase/crashlytics": "^8.3.0",
    "@capacitor-firebase/remote-config": "^8.4.0",
    "@capacitor/android": "^8.4.3",
    "@capacitor/app": "^8.1.0",
    "@capacitor/barcode-scanner": "^3.1.0",
    "@capacitor/core": "^8.4.2",
    "@capacitor/device": "^8.0.2",
    "@capacitor/ios": "^8.4.3",
    "@capacitor/push-notifications": "^8.1.2",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@growthbook/growthbook": "^1.4.1",
    "@microsoft/clarity": "^1.0.0",
    "@mongodb-js/charts-embed-dom": "^2.3.0",
    "@rolldown/binding-darwin-arm64": "^1.1.0",
    "@vuepic/vue-datepicker": "^11.0.2",
    "@vueuse/core": "^10.11.0",
    "accounting": "^0.4.1",
    "axios": "^1.18.1",
    "chart.js": "^4.5.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "core-js": "^3.45.1",
    "core-util-is": "^1.0.3",
    "date-fns": "^2.29.3",
    "dompurify": "^3.4.13",
    "dotenv": "^16.4.5",
    "firebase": "^12.18.0",
    "flag-icons": "^7.5.0",
    "heic2any": "^0.0.4",
    "humps": "^2.0.1",
    "jsona": "^1.12.1",
    "lodash-es": "^4.18.1",
    "nanoid": "^5.1.5",
    "nprogress": "^0.2.0",
    "nyc": "^18.0.0",
    "pinia": "^2.0.22",
    "qs": "^6.16.0",
    "rollbar": "^2.26.5",
    "swiper": "^12.1.2",
    "tippy.js": "^6.3.7",
    "utif": "^3.1.0",
    "valibot": "^1.4.2",
    "vite-plugin-require": "^1.3.0",
    "vue": "^3.5.14",
    "vue-chartjs": "^5.3.2",
    "vue-qrcode-reader": "^5.7.2",
    "vue-router": "^4.5.1",
    "vuedraggable": "^4.1.0",
    "vuetify": "^3.8.5",
    "webfontloader": "^1.6.28",
    "xlsx": "^0.18.5"
  },
  "devDependencies": {
    "@capacitor/cli": "^8.4.2",
    "@originjs/vite-plugin-commonjs": "^1.0.3",
    "@pinia/testing": "0.0.14",
    "@playwright/test": "^1.56.1",
    "@rushstack/eslint-patch": "^1.1.0",
    "@types/node": "^22.0.0",
    "@vitejs/plugin-vue": "^6.0.7",
    "@vue/eslint-config-prettier": "^7.0.0",
    "auto-changelog": "^2.5.0",
    "cypress": "^15.19.0",
    "deepmerge": "^4.2.2",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-cypress": "^2.12.1",
    "eslint-plugin-playwright": "^1.6.2",
    "eslint-plugin-vue": "^8.7.1",
    "eslint-plugin-vuetify": "^2.5.2",
    "husky": "^8.0.1",
    "lint-staged": "^13.0.3",
    "postcss": "^8.5.23",
    "postcss-html": "^1.5.0",
    "postcss-scss": "^4.0.5",
    "prettier": "^3.6.2",
    "release-it": "^21.0.2",
    "sass": "^1.89.0",
    "sass-embedded": "^1.89.0",
    "start-server-and-test": "^2.1.5",
    "stylelint": "^14.12.1",
    "stylelint-config-prettier": "^9.0.3",
    "stylelint-config-recommended-scss": "^7.0.0",
    "stylelint-config-recommended-vue": "^1.4.0",
    "stylelint-order": "^5.0.0",
    "terser": "^5.14.2",
    "unplugin-auto-import": "^19.2.0",
    "unplugin-fonts": "^2.0.0",
    "unplugin-vue-components": "^28.5.0",
    "unplugin-vue-router": "^0.12.0",
    "vite": "^8.1.3",
    "vite-plugin-vue-layouts-next": "^2.1.0",
    "vite-plugin-vuetify": "^2.1.1",
    "vitest": "^4.1.11"
  },
  "lint-staged": {
    "*.{vue,js}": "prettier --write",
    "*.{js,vue}": [
      "eslint --fix --config .eslintrc.cjs"
    ]
  },
  "allowScripts": {
    "cypress@13.17.0": true,
    "esbuild@0.14.54": true,
    "esbuild@0.21.5": true,
    "fsevents@2.3.2": true,
    "fsevents@2.3.3": true,
    "@parcel/watcher@2.5.6": true,
    "core-js@3.49.0": true,
    "vue-demi@0.14.10": true
  }
}
